import { floodFill, hexToRgba } from '../utils/floodFill'
import type { Tool, ToolContext, ToolPoint } from './Tool'

export class BucketTool implements Tool {
  readonly id = 'bucket'

  onPointerDown(ctx: ToolContext, point: ToolPoint): void {
    const { canvas, ctx: c, color } = ctx
    const imageData = c.getImageData(0, 0, canvas.width, canvas.height)
    floodFill(imageData, point.x, point.y, hexToRgba(color.hex), 10)
    c.putImageData(imageData, 0, 0)
  }

  onPointerMove(): void {
    /* intentionally empty */
  }

  onPointerUp(): void {
    /* intentionally empty */
  }
}
